// removed by extract-text-webpack-plugin
module.exports = {"container":"_3J9HVtBuQjdz-ob2BoEPLu","taglineContainer":"qWnq_lNuRWaiyOvAZxuCo","tagline":"_3JEz-3w4b5WBLirNJvnYnp","body":"_1iaztGPWyUstkVuENpLNt2","image":"_1NmoMfJmdvEC4tGrIQbBvJ","wineNameContainer":"_2vv6GoSWqavJwhRJNQLDpi","wineName":"_3u8giViUOspiS7vTeOyJmu","marketPrice":"IZWqf8o5OW0TpgVyn6CJJ","price":"_1X4dCBbX1AS39mjST0IRqm","text":"_3qAjkJZXF35e7_GZC3SUzu","buyButton":"mo45Os7lQ-Yu1wszl665W","buyButtonSold":"CK1JIAl3UMzzPu6qrUalO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Offer.module.scss
// module id = 469
// module chunks = 0